var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-col w-full" }, [
    _vm.is_preview && _vm.img_src
      ? _c("div", { staticClass: "vx-col w-full text-center mb-4" }, [
          _c("img", {
            staticStyle: { display: "initial", width: "50%", height: "auto" },
            attrs: { src: _vm.img_src, title: _vm.title }
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "vs-button",
                {
                  attrs: { type: "filled", color: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.onClickRemoveImage()
                    }
                  }
                },
                [_vm._v("Remove")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "vx-col w-full mb-4" }, [
      _c("div", { staticClass: "image-upload-wrap" }, [
        _c("input", {
          ref: "imageUpload",
          staticClass: "file-upload-input",
          attrs: { type: "file", accept: "image/*" },
          on: { change: _vm.onUploadImage }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "drag-text" }, [
          _c("p", { staticClass: "font-bold mb-2" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.desc))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3" }, [
      _c("small", [_c("i", [_vm._v("Preview")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }